import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ENV } from "@app/env";
import { Observable } from "rxjs/Observable";
import { catchError, retry } from "rxjs/operators";
import { AuthData } from "./auth";
import { Utilities } from "./utilities";

@Injectable()
export class PaymentProvider {

  constructor(
    private http: HttpClient,
    private utilities: Utilities,
    private authData: AuthData,
  ) { }

  public getCountrys(): Observable<any> {
    return Observable.fromPromise(this.authData.getUserData().getIdToken()).switchMap((token: any) => {
      const headers = new HttpHeaders({ Authorization: token });
      return this.http.get(`${ENV.pay_api_url}/v1/country/`, { headers })
        .pipe(retry(3), catchError((err) => [this.utilities.consoleDecorator("Error get countrys: ", err, "#004d40")]));
    });
  }

  public getCountryById(idCountry: string): Observable<any> {
    return Observable.fromPromise(this.authData.getUserData().getIdToken()).switchMap((token: any) => {
      const headers = new HttpHeaders({ Authorization: token });
      return this.http.get(`${ENV.pay_api_url}/v1/country/${idCountry}`, { headers })
        .pipe(retry(3), catchError((err) =>
          [this.utilities.consoleDecorator("Error get country by id: ", err, "#004d40")]));
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/payments.ts